<script setup lang="ts">
import { ref, watchEffect } from "vue";
import { useI18n } from "vue-i18n";

import { maskCode } from "@/common/utils/mask";

import { baseInput, baseTextarea } from "@/common/components";

import { FormPayloadType } from "@/common/types/form";

const { t } = useI18n();

const emit = defineEmits(["update-data"]);

const props = withDefaults(
  defineProps<{
    data: FormPayloadType | null;
    title?: string;
    width?: string;
  }>(),
  {
    width: "100%",
  }
);

const defaultData = {
  code: "",
  description: "",
  name: "",
};

const payload = ref<FormPayloadType>({ ...defaultData });

function update() {
  emit("update-data", payload.value);
}

watchEffect(() => {
  if (props.data) {
    payload.value = { ...props.data };
  }
});
</script>

<template>
  <section class="form-content" :style="{ width: width }">
    <div v-if="title" class="title">
      {{ title }}
    </div>
    <form>
      <base-input
        v-model="payload.code"
        :value="payload.code"
        :placeholder="t('common.placeholders.code')"
        :mask="maskCode"
        @input="update()"
      >
        <template #label>
          {{ t("common.labels.code") }}
        </template>
      </base-input>

      <base-input
        v-model="payload.name"
        :value="payload.name"
        :placeholder="t('common.placeholders.name')"
        @input="update()"
      >
        <template #label>
          {{ t("common.labels.name") }}
        </template>
      </base-input>

      <base-textarea
        v-model="payload.description"
        :value="payload.description"
        :placeholder="t('common.placeholders.describe')"
        @input="update()"
      >
        <template #label>
          {{ t("common.labels.description") }}
        </template>
      </base-textarea>
    </form>
  </section>
</template>

<style lang="scss" scoped>
.form-content {
  display: flex;
  flex-direction: column;
  gap: 1.25rem;

  .title {
    display: inline-flex;
    align-items: center;
    gap: 1rem;
    font-size: 1.5rem;
    font-weight: bold;
    text-transform: uppercase;
  }

  form {
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }
}
</style>